import { getVideos } from './videosAPI'

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit')

const initialState = {
  videos: [],
  pageCount: 0,
  totalCount: 0,
  page: 1,
  limit: 8,
  isLoading: false,
  isError: false,
  error: '',
}

// async thunk
export const fetchVideos = createAsyncThunk(
  'videos/fetchVideos',
  async ({ tags, search, page = 1, limit = 8, author }) => {
    const data = await getVideos(tags, search, page, limit, author)
    return {
      videos: data.data,
      totalCount: data.totalCount,
    }
  },
)

const videoSlice = createSlice({
  name: 'videos',
  initialState,
  reducers: {
    paginate: (state, action) => {
      state.page = action.payload.page
      state.limit = action.payload.limit
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideos.pending, (state) => {
        state.isError = false
        state.isLoading = true
      })
      .addCase(fetchVideos.fulfilled, (state, action) => {
        state.isLoading = false
        state.videos = action.payload.videos
        state.totalCount = action.payload.totalCount
        state.pageCount =
          Math.floor(action.payload.totalCount / state.limit) === 0
            ? 1
            : Math.floor(action.payload.totalCount / state.limit)
      })
      .addCase(fetchVideos.rejected, (state, action) => {
        state.isLoading = false
        state.videos = []
        state.isError = true
        state.error = action.error?.message
      })
  },
})

export default videoSlice.reducer
export const { paginate } = videoSlice.actions
